export default __webpack_public_path__ + "static/media/trend-bubble.062d68f6.png";